export function getElasticApmENV() {
    return {
        ACTIVE: import.meta.env.VITE_ELASTIC_APM_ACTIVE || false,
        SERVICE_NAME: import.meta.env.VITE_ELASTIC_APM_SERVICE_NAME || "ecv-webapp",
        SERVICE_VERSION: import.meta.env.VITE_ELASTIC_APM_SERVICE_VERSION || "1.0.0",
        SERVER_URL: import.meta.env.VITE_ELASTIC_APM_SERVER_URL,
        INSTRUMENT: import.meta.env.VITE_ELASTIC_APM_INSTRUMENT || true,
        ENVIROMENT: import.meta.env.VITE_ELASTIC_APM_ENVIROMENT || "dev",
        LOG_LEVEL: import.meta.env.VITE_ELASTIC_APM_LOG_LEVEL,
        // DISTRUBUTED_TRACING_ORIGINS returns current origin by default
        DISTRUBUTED_TRACING_ORIGINS: [window.location.origin],
    }
}


export function getElasticConfig() {
    const apmEnv = getElasticApmENV();
    console.log("elastic apm configs from env", apmEnv);

    if (!window.CONFIG.ELASTIC_APM) {
        window.CONFIG.ELASTIC_APM = {};
    }
    // add each env var to window.CONFIG if not already present 

    Object.keys(apmEnv).forEach((key) => {
        if (!window.CONFIG.ELASTIC_APM[key]) {
            window.CONFIG.ELASTIC_APM[key] = apmEnv[key];
        }
    });
    // from here on, use window.CONFIG instead of apmEnv



    return {
        active: window.CONFIG.ELASTIC_APM.ACTIVE,
        serviceName: window.CONFIG.ELASTIC_APM.SERVICE_NAME,
        serviceVersion: window.CONFIG.ELASTIC_APM.SERVICE_VERSION,
        serverUrl: window.CONFIG.ELASTIC_APM.SERVER_URL,
        instrument: window.CONFIG.ELASTIC_APM.INSTRUMENT,
        environment: window.CONFIG.ELASTIC_APM.ENVIROMENT,
        logLevel: window.CONFIG.ELASTIC_APM.LOG_LEVEL,
        distributedTracingOrigins: window.CONFIG.ELASTIC_APM.DISTRUBUTED_TRACING_ORIGINS,
    }
}

export function instumentAxios(axios) {
    if (!axios) return;

    axios.interceptors.request.use((config) => {
        var transaction = window.elasticApm.getCurrentTransaction();
        // remove query params from url
        if (!transaction) transaction = window.elasticApm.startTransaction(config.url.split("?")[0], 'ext.http');
        var trace_span = window.elasticApm.startSpan(config.url, 'ext.http');
        config.metadata = { trace_span, transaction };
        return config;
    });

    axios.interceptors.response.use((response) => {
        if (response.config.metadata) {
            response.config.metadata.trace_span.end();
            response.config.metadata.transaction.end();
        }
        return response;
    }, (error) => {
        if (error.config.metadata) {
            error.config.metadata.trace_span.end();
            error.config.metadata.transaction.end();
        }
        return Promise.reject(error);
    });
}